import React, { useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-toastify';

import ToastMessage from "../../../components/layout/ToastMessage";
import CustomizedProgressBars from '../../../components/layout/CustomizedProgressBar';
import ConfirmUpdateAccount from "../../../components/layout/ConfirmUpdateAccount";
import { sendReqeustUpdateMembership } from "../../../redux/actions/user";

export default function Membership() {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }));
  const [showUpdateAccountModal, setShowUpdateAccountModal] = useState(false);

  const daysRemaining = moment(user?.expireDate).diff(moment(), 'days');

  function getDaysRemainingText() {
    return moment(user?.expireDate).isBefore(moment()) ?
      'Expired' :
      daysRemaining + ' Day' + (daysRemaining > 1 ? 's ' : ' ') + 'Remaining';
  }
  function getDaysRemainingPercent() {
    if (moment(user?.expireDate).isBefore(moment())) {
      return 100;
    }
    const trialPeriod = moment(user?.expireDate).diff(moment(user?.expireResetDate), 'days');
    const pastPeriod = moment().diff(moment(user?.expireResetDate), 'days');
    return pastPeriod / trialPeriod * 100;
  }
  function getExpiresOnDateText() {
    return (moment(user?.expireDate).isBefore(moment()) ? "Expired" : "Expires") + " on " + moment(user?.expireDate).format('D MMMM YYYY');
  }

  const onCloseConfirmUpdateAccountModal = () => setShowUpdateAccountModal(false);
  const onShowConfirmUpdateAccountModal = () => setShowUpdateAccountModal(true);

  const onUpdateMembership = async (message) => {
    const data = {
      upgrade: user?.membership < 2,
      message,
    }

    const res = await dispatch(sendReqeustUpdateMembership(data));
    if (res.success) {
      toast(
        <ToastMessage
          title={`${data.upgrade ? 'Upgrade' : 'Cancel'} Request Sent`}
          message="Thank you. We will verify your request and get back to you." />,
          { closeButton: false }
        );
    }
    onCloseConfirmUpdateAccountModal();
  }

  return (
    <>
      <Grid>
        <Typography sx={{ fontWeight: 700, fontSize: '1.5rem' }}>Membership Settings</Typography>
      </Grid>
      <Divider sx={{ mt: 2 }} />
      <Grid container alignItems="center" sx={{ mt: 3 }}>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Membership Expiry</Typography>
          <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>{user?.membership === 2 ? 'Your membership will auto renew on your current plan' : 'Remaining period of Trial membership'}</Typography>
        </Grid>
        <Grid item container xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
          <Grid
            item
            xs={6}
            sx={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#e0e0e0', fontWeight: 700, fontSize: '1rem' }}>
            {user?.membership < 2 ? "Trial" : "Pro"} Plan
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#e0e0e0', fontWeight: 600, fontSize: '0.9rem', textAlign: 'right' }}>
            {getDaysRemainingText()}
          </Grid>
          <Grid xs={12}>
            <CustomizedProgressBars value={getDaysRemainingPercent()} />
          </Grid>
          <Typography sx={{ color: '#7E8299', fontWeight: 600, fontSize: '0.8rem', mt: 1 }}>{getExpiresOnDateText()}</Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center" sx={{ mt: 3 }}>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>
            {user?.membership === 2 ? 'Delete Account' : 'Upgrade Membership'}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>
            {user?.membership === 2 ? 'Remove account permanently' : 'Upgrade to a Pro Account'}
          </Typography>
        </Grid>
        <Grid item container xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
          <Button
            onClick={onShowConfirmUpdateAccountModal}
            variant="contained"
            color={user?.membership === 2 ? "error" : "success"}
            type="submit"
            size="large"
            sx={{ color: '#fff', fontWeight: 600, padding: '10px 30px', textTransform: 'none' }}>
            {user?.membership === 2 ? 'Cancel Account' : 'Upgrade Account'}
          </Button>
        </Grid>
      </Grid>
      <ConfirmUpdateAccount
        visible={showUpdateAccountModal}
        onClose={onCloseConfirmUpdateAccountModal}
        onClickConfirm={onUpdateMembership}
        membership={user?.membership}
      />
    </>
  );
}


